module.exports = require("@ethersproject/properties");